// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__SphaF","footer":"ModalInfo_footer__3rpfZ"};